import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';
import HintButton from '../../../../../../components/HintButton';
import {
  FORTUNA_TITLE,
  FORTUNA_SUBTITLE,
} from '../../../../../../constants/common';
import { getHotelInfo } from '../../../../store/selectors/hotel';

import type { IHotelRoulette } from '../../../../types/hotelTypes';
import { getAssets } from '../../../../store/selectors/assets';

const StyledContainer = styled.div`
  margin-bottom: 20px;
  text-align: center;
`;

const StyledImage = styled.div<{
  url: string;
  url2x: string;
  url3x: string;
  $isMobile: boolean;
}>`
  ${({ url, url2x, url3x, $isMobile }) => css`
    height: ${$isMobile ? '84px' : '113px'};
    background-image: url(${url});
    background-position: 50% 0;
    background-size: auto 100%;

    /** TODO: add autoprefixer */
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
      background-image: url(${url2x});
    }

    @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
      background-image: url(${url3x});
    }
  `}
`;

const StyledHeader = styled.div<{ $isMobile: boolean }>`
  ${({ theme }) => theme.typography.headline4};
  margin-bottom: 10px;
  padding: 0 10px;

  ${({ $isMobile, theme }) =>
    $isMobile &&
    `
    color: ${theme.colors.blackLight};
    padding: 0 20px;
  `}
`;

const StyledSubheader = styled.div<{ $isMobile: boolean }>`
  margin-bottom: 10px;
  font-size: 12px;
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.blackLight};

  ${({ $isMobile }) =>
    $isMobile &&
    `
    margin-left: 20px;
    margin-right: 20px;
  `}
`;

const StyledHintButton = styled(HintButton).attrs({
  dataAttr: 'text-hint',
  position: 'bottom',
})`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.greyLight};
`;

const StyledTextWrapper = styled.div`
  padding: 20px;
`;

const HotelRoulette = ({
  className = '',
  assets,
  tooltip,
  isMobile = false,
}: IHotelRoulette): JSX.Element => (
  <StyledContainer className={className}>
    <StyledImage
      $isMobile={isMobile}
      url={assets['packages/fortuna.jpg']}
      url2x={assets['packages/fortuna@2x.jpg']}
      url3x={assets['packages/fortuna@3x.jpg']}
    />
    <StyledTextWrapper>
      <StyledHeader $isMobile={isMobile}>{FORTUNA_TITLE}</StyledHeader>
      <StyledSubheader $isMobile={isMobile}>{FORTUNA_SUBTITLE}</StyledSubheader>
      <StyledHintButton text={tooltip}>Подробнее</StyledHintButton>
    </StyledTextWrapper>
    <StyledImage
      $isMobile={isMobile}
      url={assets['packages/fortuna-2.jpg']}
      url2x={assets['packages/fortuna-2@2x.jpg']}
      url3x={assets['packages/fortuna-2@3x.jpg']}
    />
  </StyledContainer>
);

const mapStateToProps = (state) => ({
  tooltip: getHotelInfo(state),
  isMobile: getIsMobile(state),
  assets: getAssets(state),
});

export default connect(mapStateToProps)(HotelRoulette);
